/* src/app/simplified-ordering/pages/simplified-ordering-new/simplified-ordering-new.component.scss */
/*# sourceMappingURL=simplified-ordering-new.component.css.map */
